@file:OptIn(ExperimentalWasmJsInterop::class)

package fr.arcplex.network

// The web containers proxy the legacy host under /backstage/ (Dockerfile.js /
// Dockerfile.wasm). Coil's fetcher needs an absolute URL, so the proxy path is
// resolved against the page origin instead of being handed over as "/backstage/".
@JsFun("() => window.location.origin")
private external fun pageOrigin(): String

private const val LEGACY_IMAGE_PROXY = "/backstage/"

actual fun remoteImageUrl(url: String): String =
    if (url.startsWith(LEGACY_BASE_URL)) {
        pageOrigin() + LEGACY_IMAGE_PROXY + url.removePrefix(LEGACY_BASE_URL)
    } else {
        url
    }
